import { z } from 'zod';
import type { CustomFieldQuery } from './api/useFetchCandidateProfiles';

export const searchSchema = z.object({
  keyword: z.string().optional(),
  name: z.string().optional(),
  organizationUserIds: z.array(z.number()),
  customTagIds: z.array(z.number()),
  customTagMatch: z.enum(['all', 'any']).optional(),
  age: z
    .object({
      min: z.number().nullable().optional(),
      max: z.number().nullable().optional(),
    })
    .optional(),
  includeFinished: z.boolean().optional(),
});

export type FormValue = z.infer<typeof searchSchema> & {
  customFields?: CustomFieldQuery[];
};
